import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '../utils/UserContext';
import TabBar from '../components/shared/TabBar';
import InnerTabsm from '../components/shared/InnerTabsm';
import { EditIcon, PlusIcon, CalendarIcon2, LockIcon } from '../components/shared/Icons';
import ChangePassword from './ChangePassword';
import FilterClientTickets from './FilterClientTickets';
import DepartureTicketForm from './DepartureTicketForm';
import CalendarIframe from './CalendarIframe';

const TABS = [
  { id: 'workflowclientm', label: 'Add' },
  { id: 'accountsclientm', label: 'Account' },
];

const CLIENTWORK_INNER = [
  { id: 'clientsticketm', label: 'Create Ticket', icon: <PlusIcon />, component: DepartureTicketForm },
  { id: 'ticketupdatesm', label: 'Update Tickets', icon: <EditIcon />, component: FilterClientTickets },
  { id: 'ticketcalendarm', label: 'Calendar', icon: <CalendarIcon2 />,
    component: () => <CalendarIframe url="https://airtable.com/embed/appUbsPnUAWdyKLEC/shrwa9EFvZh0NgL20?backgroundColor=dark" /> },
];

const PERSONAL_INNER = [
  { id: 'passwordm', label: 'Password', icon: <LockIcon />, component: ChangePassword },
];

const DEFAULT_TAB = 'workflowclientm';
const DEFAULT_INNER = { workflowclientm: 'clientsticketm', accountsclientm: 'passwordm' };

const FilterClientPersonalPagem = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { homeAccent } = useUser();
  const [activeTab, setActiveTab] = useState(location.state?.tab || DEFAULT_TAB);
  const [innerId, setInnerId] = useState(location.state?.inner || null);
  const [resetKey, setResetKey] = useState(location.state?.reset || 0);

  // FooterNav "New Ticket" sends { tab, inner, reset } — apply it even if we're already on
  // this route. Changing `resetKey` remounts InnerTabsm so its defaultId is honoured again.
  useEffect(() => {
    const st = location.state;
    if (!st?.tab) return;
    setActiveTab(st.tab);
    if (!st.reset) return;         // mirror-only update from the tab bar → nothing else to do
    setInnerId(st.inner || null);
    setResetKey(st.reset);
  }, [location.state]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setInnerId(null);              // user-driven tab change → that tab's normal default
    // mirror into location state (no history entry) so FooterNav highlights the matching button
    navigate(location.pathname, { replace: true, state: { tab } });
  };

  const innerFor = (tab) => innerId || DEFAULT_INNER[tab];

  return (
    <div className="fr-tab-page">
      <TabBar
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={handleTabChange}
        homeRoute="/profile"
        homeColor={homeAccent}
      />
      <div className="fr-tab-content">
        {activeTab === 'workflowclientm' && (
          <InnerTabsm key={`w-${resetKey}`} tabs={CLIENTWORK_INNER} defaultId={innerFor('workflowclientm')} />
        )}
        {activeTab === 'accountsclientm' && (
          <InnerTabsm key={`a-${resetKey}`} tabs={PERSONAL_INNER} defaultId={innerFor('accountsclientm')} />
        )}
      </div>
    </div>
  );
};

export default FilterClientPersonalPagem;